import { useRMDispatch, useRMSelector } from 'redux/hooks';
import {
  setImagerGroupPlateQuota,
  setImagerQuotaIsDirty,
  setImagerQuotaList,
} from 'redux/reducers/imagerQuotaReducer';
import { saveImagerQuota } from 'redux/thunks/imagerQuota';

export const useImagerQuotaIsDirty = () => {
  return useRMSelector((state) => state?.imagerQuota?.isDirty);
};

export const useImagerQuota = () => {
  return useRMSelector((state) => state?.imagerQuota?.imagerQuotaList);
};

export const useOriginalImagerQuota = () => {
  return useRMSelector((state) => state?.imagerQuota?.imagerQuotaOriginalList);
};

export const onUpdateImagerQuotaList = () => {
  const dispatch = useRMDispatch();
  return (quotaList) => {
    dispatch(setImagerQuotaList(quotaList));
  };
};

export const onUpdateImagerQuotaDirty = () => {
  const dispatch = useRMDispatch();
  return (isDirty) => {
    dispatch(setImagerQuotaIsDirty(isDirty));
  };
};

export const onUpdateImagerGroups = () => {
  const dispatch = useRMDispatch();
  return (selectedQuotaId, imagerGroups) => {
    dispatch(
      setImagerGroupPlateQuota({
        selectedQuotaId: selectedQuotaId,
        imagerGroups: imagerGroups,
      }),
    );
  };
};

export const useOnSaveImagerQuota = () => {
  const dispatch = useRMDispatch();
  return (imagerQuotaList) => {
    dispatch(saveImagerQuota(imagerQuotaList));
  };
};
